import { gql, GqlFragment } from 'src/utils/gql/query';
import { RequiredDeep } from 'ts-toolbelt/out/Object/Required';
import {
  BodyParts,
  Durations,
  Languages,
  Subjects,
  Tags,
} from 'src/graphql/schema.graphql';

export const videoSearchFiltersGqlQuery: GqlFragment<{
  subjects: RequiredDeep<Subjects[]>;
  tags: RequiredDeep<Tags[]>;
  bodyParts: RequiredDeep<BodyParts[]>;
  durations: RequiredDeep<Durations[]>;
  languages: RequiredDeep<Languages[]>;
}> = gql`
  query {
    subjects {
      id
      slug
      translations {
        name
        languages_id {
          code
        }
      }
    }
    tags(filter: { videos: { videos_id: { id: { _nnull: true } } } }) {
      id
      slug
      translations {
        name
        languages_code {
          code
        }
      }
    }
    bodyParts {
      id
      slug
    }
    durations {
      id
      slug
      translations {
        name
        languages_code {
          code
        }
      }
    }
    languages {
      name
      code
    }
  }
`;
